import {
  CREATE_EVENT,
  CREATE_EVENT_SUCCESS,
  CREATE_EVENT_ERROR,
  CREATE_EVENT_CLEAN,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  event: undefined,
}

const EventCreate = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_EVENT:
      state = {
        ...state,
        loading: true,
      }
      break
    case CREATE_EVENT_SUCCESS:
      state = {
        ...state,
        event: action.payload.event,
        loading: false,
        done: true,
      }
      break
    case CREATE_EVENT_ERROR:
      state = {
        ...state,
        error: action.payload,
        event: undefined,
        loading: false,
        done: false,
      }
      break
    case CREATE_EVENT_CLEAN:
      state = initialState
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default EventCreate
